import OrganizationView from 'src/sections/settings/organization/view';

export default function OrganizationPage() {
  return <OrganizationView />;
}
